export class LikedProducts {
    sndevice: string;
    menuId: number;
    productId: number;
    status: boolean;

    constructor(sndevice: string, menuId: number, productId: number, status: boolean) {
        this.sndevice = sndevice;
        this.menuId = menuId;
        this.productId = productId;
        this.status = status;
      }
}
